<template>
  <div class="point_error">
    <section class="text_center">
      <h2 class="header_underline">NetRideCash決済キャンセル</h2>
      <p class="point_error_notice">NetRideCash決済をキャンセルしました。</p>
      <p>
      <router-link :to="{ name: 'PointNetridecashForm' }" class="arrow link_main--text">ポイント購入ページに戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PointNetridecashCancel'
}
</script>
